<div class="profile-dropdown-container" [class.is-open]="open()">
  <button
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    class="btn btn-light dropdown-trigger"
    type="button"
    (click)="toggle()"
  >
    <div class="profile-selection-button-content">
      <span
        class="profile-selection-icon {{ getIconClassForDropdown(selected()) }}"
      ></span>
      <div class="profile-selection-button-text">
        <span>{{ selected()?.name }}</span>
        <span class="profile-selection-type">
          {{
            selected()?.type === "person"
              ? ("profileSelector.type.person" | translate)
              : selected()?.type === "legalProfessional"
                ? ("profileSelector.type.legalProfessional" | translate)
                : selected()?.type === "legalEntity"
                  ? ("profileSelector.type.legalEntity" | translate)
                  : ""
          }}
        </span>
      </div>
    </div>
    <span class="caret"></span>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open()"
    (backdropClick)="close()"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  >
    <ul class="dropdown-menu">
      @if (currentUserAsAccount(); as userAccount) {
        @if (userAccount.id !== selected()?.id) {
          <li (click)="selectUser()">
            <button class="btn btn-light" type="button">
              <div class="profile-selection-button-content">
                <span
                  class="profile-selection-icon {{
                    getIconClassForDropdown(userAccount)
                  }}"
                ></span>
                <div class="profile-selection-button-text">
                  <span>{{ userAccount.name }}</span>
                  <span class="profile-selection-type">
                    {{
                      userAccount.type === "person"
                        ? ("profileSelector.type.person" | translate)
                        : userAccount.type === "legalProfessional"
                          ? ("profileSelector.type.legalProfessional"
                            | translate)
                          : ("profileSelector.type.legalEntity" | translate)
                    }}
                  </span>
                </div>
              </div>
            </button>
          </li>
        }
      }
      @for (option of filteredSubAccounts(); track option.id) {
        <li
          (click)="
            option.enabled && !option.suspended && selectSubAccount(option)
          "
        >
          <button
            class="btn btn-light"
            type="button"
            [disabled]="!option.enabled || option.suspended"
          >
            <div class="profile-selection-button-content flex-between-center">
              <div class="profile-selection-button-text-container">
                <div class="profile-selection-icon-container">
                  <span
                    class="profile-selection-icon {{
                      getIconClassForDropdown(option)
                    }}"
                  ></span>
                </div>
                <div class="profile-selection-button-text">
                  <span> {{ option.name }}</span>
                  <span class="profile-selection-type">
                    {{
                      option.type === "person"
                        ? ("profileSelector.type.person" | translate)
                        : option.type === "legalProfessional"
                          ? ("profileSelector.type.legalProfessional"
                            | translate)
                          : ("profileSelector.type.legalEntity" | translate)
                    }}
                  </span>
                </div>
              </div>

              @if (!option.enabled) {
                <span class="badge badge-subtle-warning badge-pending ms-2">
                  {{ "general.pending" | translate }}
                </span>
              } @else if (
                option.enabled &&
                option.type !== 'legalProfessional' &&
                option.stepInvestorQualification === null
              ) {
                <span
                  class="badge badge-subtle-warning badge-not-qualified ms-2"
                >
                  {{ "generic.investorQualification.NotQualified" | translate }}
                </span>
              }
            </div>
          </button>
        </li>
      }

      <li class="add-new-btn-container">
        <app-button
          class="add-new-btn"
          [label]="'profileSelector.addProfile' | translate"
          [btnClass]="
            'btn btn-primary w-100 px-4 d-flex align-items-center justify-content-center gap-2'
          "
          [iconClass]="'fas fa-plus'"
          (clicked)="addNewSubAccount()"
        ></app-button>
      </li>
    </ul>
  </ng-template>
</div>
